import React from 'react';
import { CloseButton, Popover, View, IconQuestionLine } from '@instructure/ui';
import { useState } from 'react';
import parse from 'html-react-parser';
const ItemCriteria = ({ criteria }) => {
  const [isShowingContent, setIsShowingContent] = useState(false);

  return (
    <>
      {criteria && (
        <View>
          <Popover
            renderTrigger={<IconQuestionLine />}
            on="hover"
            screenReaderLabel="Popover Dialog Example"
            shouldContainFocus
            shouldReturnFocus
            shouldCloseOnDocumentClick
            offsetX="10px"
            placement="bottom start"
          >
            <View padding="medium" display="block" as="form">
              {parse(criteria)}
            </View>
          </Popover>
        </View>
      )}
    </>
  );
};

export default ItemCriteria;
